define('bindingHandlers/resize',[
    'jquery',
    'lib/knockout',
    //no references required
    'lib/jQueryUI'
], function ($, ko) {
    'use strict';

    function addHandle($parent, handles, selector, direction) {
        if (selector) {
            var $handle = $parent.find(selector);
            if ($handle) {
                // jqueryUI resizable needs these classes on the handles
                $handle.addClass('ui-resizable-handle ui-resizable-' + direction);
                handles[direction] = $handle;
            }
        }
    }

    /**
     * A binding handler making an element resizable.  When this is applied to an element, a User can click/drag a
     * handle to resize the element.  The handles are child elements that the user will actually click/drag to
     * perform the resize.  They must be child elements of the element being re-sized.
     *
     * # Required Arguments
     *
     * @param {Object} value - An options object that needs to have the following property:
     *          @param {Object} handles -  An object that defines the handles that will be used for resizing.
     *                                     If a handle is not provided, then that element cannot be resized from that side.
     *                                     The possible handle properties are:  'top', 'left', 'right', and 'bottom'.
     *                                     The value of each property should be a selector for the handle element.
     *
     *
     * # Example
     *
     *   <div data-bind="resize: {
     *        handles: {
     *               top: '.top-handle',
     *               left: '.left-handle',
     *               right: '.right-handle',
     *               bottom: '.bottom-handle'
     *        }
     *   }">
     *      <div class="top-handle"></div>
     *      <div class="left-handle"></div>
     *      <div class="right-handle"></div>
     *      <div class="bottom-handle"></div>
     *   </div>
     *
     */
    ko.bindingHandlers.resize = {
        init: function(element, valueAccessor) {
            var $element = $(element);
            var options = valueAccessor();
            var handles = {};
            addHandle($element, handles, options.handles.top, 'n');
            addHandle($element, handles, options.handles.bottom, 's');
            addHandle($element, handles, options.handles.left, 'w');
            addHandle($element, handles, options.handles.right, 'e');

            $element.resizable({
                handles: handles,
                containment: 'parent'
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                $(element).resizable('destroy');
            });
        }
    };
});

